import Immutable from 'immutable';
import * as types from './Editor.types';

const initialState = {
    templateCode: null,
    variables: {
        name: '',
        department1: '',
        department2: '',
        department3: '',
        phone: '',
        clinic: '',
        fax: '',
        pager: '',
        nursePhone: '',
        address: '',
        address2: '',
        address3: '',
        city: '',
        state: '',
        zip: '',
        showEmail: 1,
        open1: '',
        open2: '',
        open3: '',
        quantity: '',
        frontDataUrl: '',
        backDataUrl: '',
        showCell: 1,
        locationNames: [],
        locationPhones: [],
        locationFaxes: [],
        locationNursePhones: [],
        locationAddresses1: [],
        locationAddresses2: [],
        locationAddresses3: [],
        locationCities: [],
        locationStates: [],
        locationZips: [],
        locationSuites: [],
        locations: 0,
        color: 1,
        stock: '',
        titles: [],
        personsNames: [],
        personsTitles: [],
        notes: '',
        contact1Phone: '',
        contact1Type: '',
        contact2Phone: '',
        contact2Type: '',
        quantity1: '0',
        quantity2: '0',
        quantity3: '0',
        window: 0,

        // New UTH July 2022
        front: 1,
        back: 1,
        suiteRoom: '',
        firstName: '',
        middleName: '',
        lastName: '',
        credentials: '',
        primaryTitle: '',
        title1: '',
        title2: '',
        title3: '',
        secondaryTitle: '',
        title4: '',
        email: '',
        main: '',
        direct: '',
        cell: '',
        website: '',
        addEnvelopes: 0,
        letterheadPersons: [
            { name: '', titles: [''] },
        ],
        prescriptionPadDoctors: [
            { name: '', lic: '', dea: '' },
        ],
        additionalField: 1,
        schedulingCard: 1,

        showSocialMediaIcons: 0,
        phoneLabel1: 'Main',
        phoneLabel2: 'Direct',
        phoneLabel3: 'Cell',
        phoneOtherLabel1: '',
        phoneOtherLabel2: '',
        phoneOtherLabel3: '',
        language: '',
        location_id: '',
        clinic_id: '',

        // New UTH April 2025
        fontType: 'sans-serif',


        /***** Testing new cards *****/ 
        // suiteRoom: 'Ella Blv.',
        // address2: 'Houston, TX 77041',
        // firstName: 'Diego',
        // lastName: 'Salazar',
        // credentials: 'MCC',
        // primaryTitle: 'Professor and Chief, Pediatric and Congenital Heart Surgery',
        // title1: 'UTHealth Houston Office of Public Affairs',
        // title2: 'Creative Designer',
        // title3: 'Graphic Communication',
        // email: 'John.Smith@uth.tmc.edu',
        // main: '713-500-3220',
        // cell: '832-693-1070',
        // website: 'uth.edu/brand-standards',
    },
    addingToCart: false,
    isFavorite: false,
    addingFavorite: false,
    checkingFavorite: false,
    savingWork: false,
    action: null,
    addToCartOrderType: null,
    addToCartType: null,
    password: '',
    showChecks: false,
    fetchingCheckControl: false,
    checkControl: {
        date: null,
        start: 0,
        end: 0,
    },
    clinics: [],
    fetchingClinics: false,
    clinicLocations: [],
    fetchingClinicLocations: false,
    availableItems: null,
    fetchingAvailableItems: false,
}

export default function (state = initialState, action) {
    state = Immutable.fromJS(state);
    switch (action.type) {
        case types.SET_TEMPLATE_CODE:
            return state.setIn(['templateCode'], action.payload).toJS();

        case types.SET_NAME:
            return state.setIn(['variables', 'name'], action.payload).toJS();

        case types.SET_CREDENTIALS:
            return state.setIn(['variables', 'credentials'], action.payload).toJS();

        case types.SET_TITLE1:
            return state.setIn(['variables', 'title1'], action.payload).toJS();

        case types.SET_TITLE2:
            return state.setIn(['variables', 'title2'], action.payload).toJS();

        case types.SET_TITLE3:
            return state.setIn(['variables', 'title3'], action.payload).toJS();

        case types.SET_DEPARTMENT1:
            return state.setIn(['variables', 'department1'], action.payload).toJS();

        case types.SET_DEPARTMENT2:
            return state.setIn(['variables', 'department2'], action.payload).toJS();

        case types.SET_DEPARTMENT3:
            return state.setIn(['variables', 'department3'], action.payload).toJS();

        case types.SET_PHONE:
            return state.setIn(['variables', 'phone'], action.payload).toJS();

        case types.SET_CLINIC:
            return state.setIn(['variables', 'clinic'], action.payload).toJS();

        case types.SET_FAX:
            return state.setIn(['variables', 'fax'], action.payload).toJS();

        case types.SET_PAGER:
            return state.setIn(['variables', 'pager'], action.payload).toJS();

        case types.SET_ADDRESS:
            return state.setIn(['variables', 'address'], action.payload).toJS();

        case types.SET_ADDRESS2:
            return state.setIn(['variables', 'address2'], action.payload).toJS();

        case types.SET_ADDRESS3:
            return state.setIn(['variables', 'address3'], action.payload).toJS();

        case types.SET_CITY:
            return state.setIn(['variables', 'city'], action.payload).toJS();

        case types.SET_STATE:
            return state.setIn(['variables', 'state'], action.payload).toJS();

        case types.SET_ZIP:
            return state.setIn(['variables', 'zip'], action.payload).toJS();

        case types.SET_EMAIL:
            return state.setIn(['variables', 'email'], action.payload).toJS();

        case types.SET_SHOW_EMAIL:
            return state.setIn(['variables', 'showEmail'], action.payload).toJS();

        case types.SET_OPEN1:
            return state.setIn(['variables', 'open1'], action.payload).toJS();

        case types.SET_OPEN2:
            return state.setIn(['variables', 'open2'], action.payload).toJS();

        case types.SET_OPEN3:
            return state.setIn(['variables', 'open3'], action.payload).toJS();

        case types.SET_QUANTITY:
            return state.setIn(['variables', 'quantity'], action.payload).toJS();

        case types.SET_FRONT_DATA_URL:
            return state.setIn(['variables', 'frontDataUrl'], action.payload).toJS();

        case types.SET_BACK_DATA_URL:
            return state.setIn(['variables', 'backDataUrl'], action.payload).toJS();

        case types.SET_CELL:
            return state.setIn(['variables', 'cell'], action.payload).toJS();

        case types.SET_SHOW_CELL:
            return state.setIn(['variables', 'showCell'], action.payload).toJS();

        case types.SET_LOCATION_NAMES:
            return state.setIn(['variables', 'locationNames'], action.payload).toJS();

        case types.SET_LOCATION_PHONES:
            return state.setIn(['variables', 'locationPhones'], action.payload).toJS();

        case types.SET_LOCATION_FAXES:
            return state.setIn(['variables', 'locationFaxes'], action.payload).toJS();

        case types.SET_LOCATION_NURSE_PHONES:
            return state.setIn(['variables', 'locationNursePhones'], action.payload).toJS();

        case types.SET_LOCATION_ADDRESSES1:
            return state.setIn(['variables', 'locationAddresses1'], action.payload).toJS();

        case types.SET_LOCATION_ADDRESSES2:
            return state.setIn(['variables', 'locationAddresses2'], action.payload).toJS();

        case types.SET_LOCATION_ADDRESSES3:
            return state.setIn(['variables', 'locationAddresses3'], action.payload).toJS();

        case types.SET_LOCATION_SUITES:
            return state.setIn(['variables', 'locationSuites'], action.payload).toJS();

        case types.SET_LOCATION_CITIES:
            return state.setIn(['variables', 'locationCities'], action.payload).toJS();

        case types.SET_LOCATION_STATES:
            return state.setIn(['variables', 'locationStates'], action.payload).toJS();

        case types.SET_LOCATION_ZIPS:
            return state.setIn(['variables', 'locationZips'], action.payload).toJS();

        case types.SET_COLOR:
            return state.setIn(['variables', 'color'], action.payload).toJS();

        case types.SET_STOCK:
            return state.setIn(['variables', 'stock'], action.payload).toJS();

        case types.SET_TITLES:
            return state.setIn(['variables', 'titles'], action.payload).toJS();

        case types.SET_NOTES:
            return state.setIn(['variables', 'notes'], action.payload).toJS();

        case types.SET_CONTACT1_PHONE:
            return state.setIn(['variables', 'contact1Phone'], action.payload).toJS();

        case types.SET_CONTACT1_TYPE:
            return state.setIn(['variables', 'contact1Type'], action.payload).toJS();

        case types.SET_CONTACT2_PHONE:
            return state.setIn(['variables', 'contact2Phone'], action.payload).toJS();

        case types.SET_CONTACT2_TYPE:
            return state.setIn(['variables', 'contact2Type'], action.payload).toJS();

        case types.SET_QUANTITY1:
            return state.setIn(['variables', 'quantity1'], action.payload).toJS();

        case types.SET_QUANTITY2:
            return state.setIn(['variables', 'quantity2'], action.payload).toJS();

        case types.SET_QUANTITY3:
            return state.setIn(['variables', 'quantity3'], action.payload).toJS();

        case types.SET_LOCATIONS:
            return state.setIn(['variables', 'locations'], action.payload).toJS();

        case types.ADD_TITLE:
            return state.updateIn(['variables', 'titles'], (titles) => {
                const newTitles = titles.toJS();
                newTitles.push('');
                return newTitles;
            }).toJS();

        case types.REMOVE_TITLE:
            return state.updateIn(['variables', 'titles'], (titles) => {
                const newTitles = titles.toJS();
                newTitles.pop();
                return newTitles;
            }).toJS();

        case types.SET_PERSONS_NAMES:
            return state.setIn(['variables', 'personsNames'], action.payload).toJS();

        case types.SET_PERSONS_TITLES:
            return state.setIn(['variables', 'personsTitles'], action.payload).toJS();

        case types.ADD_PERSON:
            return state.updateIn(['variables', 'personsNames'], (personsNames) => {
                const newNames = personsNames.toJS();
                newNames.push('');
                return newNames;
            }).updateIn(['variables', 'personsTitles'], (personsTitles) => {
                const newTitles = personsTitles.toJS();
                newTitles.push('');
                return newTitles;
            }).toJS();

        case types.REMOVE_PERSON:
            return state.updateIn(['variables', 'personsNames'], (personsNames) => {
                const newNames = personsNames.toJS();
                newNames.pop();
                return newNames;
            }).updateIn(['variables', 'personsTitles'], (personsTitles) => {
                const newTitles = personsTitles.toJS();
                newTitles.pop();
                return newTitles;
            }).toJS();

        case types.ADD_TO_CART:
            if (parseInt(action.payload) === 2) {
                return state.setIn(['savingWork'], true).toJS();
            }
            return state.setIn(['addingToCart'], true).toJS();

        case types.ADD_TO_CART_SUCCESS:
            return state.setIn(['addingToCart'], false)
                .setIn(['savingWork'], false)
                .toJS();

        case types.ADD_TO_CART_ERROR:
            return state.setIn(['addingToCart'], false)
                .setIn(['savingWork'], false)
                .toJS();

        case types.ADD_FAVORITE:
            return state.setIn(['addingFavorite'], true).toJS();

        case types.ADD_FAVORITE_SUCCESS:
            return state.setIn(['addingFavorite'], false)
                .setIn(['isFavorite'], parseInt(action.payload.type) === 1)
                .toJS();

        case types.ADD_FAVORITE_ERROR:
            return state.setIn(['addingFavorite'], false).toJS();

        case types.CHECK_FAVORITE:
            return state.setIn(['checkingFavorite'], true).toJS();

        case types.CHECK_FAVORITE_SUCCESS:
            return state.setIn(['checkingFavorite'], false)
                .setIn(['isFavorite'], parseInt(action.payload.favorite) === 1)
                .toJS();

        case types.CHECK_FAVORITE_ERROR:
            return state.setIn(['checkingFavorite'], false).toJS();

        case types.FETCH_CHECK_CONTROL:
            return state.setIn(['fetchingCheckControl'], true).toJS();

        case types.FETCH_CHECK_CONTROL_SUCCESS:
            return state.setIn(['fetchingCheckControl'], false)
                .setIn(['checkControl'], action.payload)
                .toJS();

        case types.FETCH_CHECK_CONTROL_ERROR:
            return state.setIn(['fetchingCheckControl'], false).toJS();

        case types.FETCH_CLINICS:
            return state.setIn(['fetchingClinics'], true).toJS();

        case types.FETCH_CLINICS_SUCCESS:
            return state.setIn(['fetchingClinics'], false)
                .setIn(['clinics'], action.payload)
                .toJS();

        case types.FETCH_CLINICS_ERROR:
            return state.setIn(['fetchingClinics'], false).toJS();

        case types.FETCH_CLINIC_LOCATIONS:
            return state.setIn(['fetchingClinicLocations'], true).toJS();

        case types.FETCH_CLINIC_LOCATIONS_SUCCESS:
            return state.setIn(['fetchingClinicLocations'], false)
                .setIn(['clinicLocations'], action.payload)
                .setIn(['variables', 'location_id'], action.payload.length > 0 ? action.payload[0].id : '')
                .toJS();

        case types.FETCH_CLINIC_LOCATIONS_ERROR:
            return state.setIn(['fetchingClinicLocations'], false).toJS();

        case types.CHECK_AVAILABLE_ITEMS:
            return state.setIn(['fetchingAvailableItems'], true).toJS();

        case types.CHECK_AVAILABLE_ITEMS_SUCCESS:
            return state.setIn(['fetchingAvailableItems'], false)
                .setIn(['availableItems'], action.payload)
                .toJS();

        case types.CHECK_AVAILABLE_ITEMS_ERROR:
            return state.setIn(['fetchingAvailableItems'], false).toJS();

        case types.SET_ACTION:
            return state.setIn(['action'], action.payload).toJS();

        case types.SET_ADD_TO_CART_ORDER_TYPE:
            return state.setIn(['addToCartOrderType'], action.payload).toJS();

        case types.SET_ADD_TO_CART_TYPE:
            return state.setIn(['addToCartType'], action.payload).toJS();

        case types.SET_PASSWORD:
            return state.setIn(['password'], action.payload).toJS();

        case types.SET_SHOW_CHECKS:
            return state.setIn(['showChecks'], action.payload).toJS();

        case types.SET_FRONT:
            return state.setIn(['variables', 'front'], action.payload).toJS();

        case types.SET_BACK:
            return state.setIn(['variables', 'back'], action.payload).toJS();

        case types.SET_SUITE_ROOM:
            return state.setIn(['variables', 'suiteRoom'], action.payload).toJS();

        case types.SET_FIRST_NAME:
            return state.setIn(['variables', 'firstName'], action.payload).toJS();

        case types.SET_MIDDLE_NAME:
            return state.setIn(['variables', 'middleName'], action.payload).toJS();

        case types.SET_LAST_NAME:
            return state.setIn(['variables', 'lastName'], action.payload).toJS();

        case types.SET_PRIMARY_TITLE:
            return state.setIn(['variables', 'primaryTitle'], action.payload).toJS();

        case types.SET_SECONDARY_TITLE:
            return state.setIn(['variables', 'secondaryTitle'], action.payload).toJS();

        case types.SET_TITLE4:
            return state.setIn(['variables', 'title4'], action.payload).toJS();

        case types.SET_MAIN:
            return state.setIn(['variables', 'main'], action.payload).toJS();

        case types.SET_DIRECT:
            return state.setIn(['variables', 'direct'], action.payload).toJS();

        case types.SET_WEBSITE:
            return state.setIn(['variables', 'website'], action.payload).toJS();

        case types.SET_SCHEDULING_CARD:
            return state.setIn(['variables', 'schedulingCard'], action.payload).toJS();

        case types.SET_ADD_ENVELOPES:
            return state.setIn(['variables', 'addEnvelopes'], action.payload).toJS();

        case types.SET_ADDITIONAL_FIELD:
            return state.setIn(['variables', 'additionalField'], action.payload).toJS();

        case types.ADD_LETTERHEAD_PERSON:
            return state.updateIn(['variables', 'letterheadPersons'], (letterheadPersons) => {
                const newPersons = letterheadPersons.toJS();
                newPersons.push({
                    name: '',
                    titles: [''],
                });

                for (let i = 0; i < newPersons.length; i++) {
                    newPersons[i].titles.splice(1);
                }

                return newPersons;
            }).toJS();

        case types.REMOVE_LETTERHEAD_PERSON:
            return state.updateIn(['variables', 'letterheadPersons'], (letterheadPersons) => {
                const newPersons = letterheadPersons.toJS();
                newPersons.pop();
                return newPersons;
            }).toJS();

        case types.SET_LETTERHEAD_PERSON_NAME:
            return state.updateIn(['variables', 'letterheadPersons'], (letterheadPersons) => {
                const newPersons = letterheadPersons.toJS();
                newPersons[action.payload.index].name = action.payload.value;
                return newPersons;
            }).toJS();

        case types.ADD_LETTERHEAD_PERSON_TITLE:
            return state.updateIn(['variables', 'letterheadPersons'], (letterheadPersons) => {
                const newPersons = letterheadPersons.toJS();
                newPersons[action.payload].titles.push('');
                return newPersons;
            }).toJS();

        case types.REMOVE_LETTERHEAD_PERSON_TITLE:
            return state.updateIn(['variables', 'letterheadPersons'], (letterheadPersons) => {
                const newPersons = letterheadPersons.toJS();
                newPersons[action.payload].titles.pop();
                return newPersons;
            }).toJS();

        case types.SET_LETTERHEAD_PERSON_TITLE:
            return state.updateIn(['variables', 'letterheadPersons'], (letterheadPersons) => {
                const newPersons = letterheadPersons.toJS();
                newPersons[action.payload.personIndex].titles[action.payload.titleIndex] = action.payload.value;
                return newPersons;
            }).toJS();

        case types.ADD_PRESCRIPTION_PAD_PERSON:
            return state.updateIn(['variables', 'prescriptionPadDoctors'], (prescriptionPadDoctors) => {
                const newDoctors = prescriptionPadDoctors.toJS();
                newDoctors.push({ name: '', lic: '', dea: '' });
                return newDoctors;
            }).toJS();

        case types.REMOVE_PRESCRIPTION_PAD_PERSON:
            return state.updateIn(['variables', 'prescriptionPadDoctors'], (prescriptionPadDoctors) => {
                const newDoctors = prescriptionPadDoctors.toJS();
                newDoctors.pop();
                return newDoctors;
            }).toJS();

        case types.REMOVE_PRESCRIPTION_PAD_PERSON_BY_INDEX:
            return state.updateIn(['variables', 'prescriptionPadDoctors'], (prescriptionPadDoctors) => {
                const newDoctors = prescriptionPadDoctors.toJS();
                newDoctors.splice(action.payload, 1);
                return newDoctors;
            }).toJS();

        case types.SET_PRESCRIPTION_PAD_PERSON_FIELD:
            return state.updateIn(['variables', 'prescriptionPadDoctors'], (prescriptionPadDoctors) => {
                const newDoctors = prescriptionPadDoctors.toJS();
                newDoctors[action.payload.index][action.payload.field] = action.payload.value;
                return newDoctors;
            }).toJS();

        case types.SET_LETTERHEAD_PERSONS:
            return state.setIn(['variables', 'letterheadPersons'], action.payload).toJS();

        case types.SET_PRESCRIPTION_PAD_PERSONS:
            return state.setIn(['variables', 'prescriptionPadDoctors'], action.payload).toJS();

        case types.SET_WINDOW:
            return state.setIn(['variables', 'window'], action.payload).toJS();

        case types.SET_SHOW_SOCIAL_MEDIA_ICONS:
            return state.setIn(['variables', 'showSocialMediaIcons'], action.payload).toJS();

        case types.SET_PHONE_LABEL1:
            return state.setIn(['variables', 'phoneLabel1'], action.payload).toJS();

        case types.SET_PHONE_LABEL2:
            return state.setIn(['variables', 'phoneLabel2'], action.payload).toJS();

        case types.SET_PHONE_LABEL3:
            return state.setIn(['variables', 'phoneLabel3'], action.payload).toJS();

        case types.SET_PHONE_OTHER_LABEL1:
            return state.setIn(['variables', 'phoneOtherLabel1'], action.payload).toJS();

        case types.SET_PHONE_OTHER_LABEL2:
            return state.setIn(['variables', 'phoneOtherLabel2'], action.payload).toJS();

        case types.SET_PHONE_OTHER_LABEL3:
            return state.setIn(['variables', 'phoneOtherLabel3'], action.payload).toJS();

        case types.SET_LANGUAGE:
            return state.setIn(['variables', 'language'], action.payload).toJS();

        case types.SET_LOCATION_ID:
            return state.setIn(['variables', 'location_id'], action.payload).toJS();

        case types.SET_CLINIC_ID:
            return state.setIn(['variables', 'clinic_id'], action.payload).toJS();
            
        case types.SET_NURSE_PHONE:
            return state.setIn(['variables', 'nursePhone'], action.payload).toJS();

        case types.SET_FONT_TYPE:
            return state.setIn(['variables', 'fontType'], action.payload).toJS();

        case types.RESET_STATE:
            return initialState;

        default:
            return state.toJS();
    }
}